const palettes = {
    "red": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
                "a": 0
            },
            {
                "r": 104,
                "g": 72,
                "b": 96
            },
            {
                "r": 192,
                "g": 168,
                "b": 184
            },
            {
                "r": 224,
                "g": 224,
                "b": 224
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 96,
                "g": 40,
                "b": 32
            },
            {
                "r": 168,
                "g": 48,
                "b": 40
            },
            {
                "r": 224,
                "g": 16,
                "b": 16
            },
            {
                "r": 248,
                "g": 80,
                "b": 72
            },
            {
                "r": 56,
                "g": 208,
                "b": 48
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    },
    "blue": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
                "a": 0
            },
            {
                "r": 88,
                "g": 72,
                "b": 120
            },
            {
                "r": 144,
                "g": 184,
                "b": 232
            },
            {
                "r": 216,
                "g": 232,
                "b": 240
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 56,
                "g": 56,
                "b": 144
            },
            {
                "r": 56,
                "g": 80,
                "b": 224
            },
            {
                "r": 40,
                "g": 160,
                "b": 248
            },
            {
                "r": 24,
                "g": 240,
                "b": 248
            },
            {
                "r": 232,
                "g": 16,
                "b": 24
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    }
}

function areSameColor(a, b) {
    return a.r == b.r
        && a.g == b.g
        && a.b == b.b
}

function getColorAtIndex(array, index) {
    return {
        "r": array[index + 0],
        "g": array[index + 1],
        "b": array[index + 2],
        "a": array[index + 3],
    }
}

function setColorAtIndex(array, index, color) {
    array[index + 0] = color.r ?? 0
    array[index + 1] = color.g ?? 0
    array[index + 2] = color.b ?? 0
    array[index + 3] = color.a ?? 255
}

export default function PaletteSwapped(imageElement, paletteKey) {
    if(imageElement == undefined) return undefined
    if(imageElement.isLoaded != true) return undefined

    if(paletteKey == undefined) return undefined
    if(palettes[paletteKey] == undefined) return undefined

    const canvas = document.createElement("canvas")
    canvas.context = canvas.getContext("2d")
    canvas.width = 64
    canvas.height = 48

    canvas.context.drawImage(imageElement, 0, 0)

    if(paletteKey == "blue") return canvas.toDataURL()

    const pixels = canvas.context.getImageData(0, 0, canvas.width, canvas.height)
    for(let index = 0; index < pixels.data.length; index += 4) {
        const sampledColor = getColorAtIndex(pixels.data, index)

        const BASE_PALETTE = palettes["blue"]
        BASE_PALETTE.colors.find((color, colorIndex) => {
            if(areSameColor(color, sampledColor)) {
                setColorAtIndex(pixels.data, index, palettes[paletteKey].colors[colorIndex])
            }
        })
    }
    canvas.context.putImageData(pixels, 0, 0)

    return canvas.toDataURL()
}
